/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'linkedin': {
    width: 500,
    height: 500,
    viewBox: '0 0 500 500',
    data: '<path pid="0" _fill="#1B1625" d="M428.821 39H70.111C52.918 39 39 52.567 39 69.292V429.64c0 16.842 13.918 30.41 31.11 30.41h358.83c17.076 0 31.11-13.568 31.11-30.41V69.292C460.05 52.567 446.016 39 428.821 39zm-264.91 358.83H101.34V196.893h62.455v200.935h.118zm-31.227-228.421c-20.117 0-36.258-16.258-36.258-36.257 0-20 16.14-36.14 36.258-36.14 20 0 36.14 16.256 36.14 36.14 0 20-16.14 36.257-36.14 36.257zm265.027 228.42h-62.455v-97.661c0-23.275-.468-53.333-32.397-53.333-32.515 0-37.428 25.38-37.428 51.579v99.415h-62.338V196.894h59.882v27.485h.819c8.304-15.79 28.772-32.398 59.065-32.398 63.157 0 74.852 41.638 74.852 95.672V397.83z"/>'
  }
})
